export const ModuloIdEnum = {
    CadastroNacionalCurso: { id: "FB80ADD1-91FE-4DA0-B900-0222DFCEFE59", nome: 'Cadastro Nacional de Cursos' },
    SumarioExecutivo: { id: "D0E31A61-AF44-42E6-986E-0658668972BB", nome: 'Sumário Executivo' },
    CentralNotificacoes: { id: "AF2856A2-2757-40E1-B113-15DD1F12E31A", nome: 'Central de Notificações' },
    IntegracaoDataWarehouse: { id: "9812FDAD-33C6-4C89-9A79-2311F8EC640B", nome: 'Integração Data Warehouse' },
    Investimentos: { id: "B3A2ED0B-56E6-443A-8529-2AA68BBD6DB4", nome: 'Investimentos' },
    DadosEstrategicos: { id: "8D83B29F-E16D-4A5D-A5C0-3AFE4723E63F", nome: 'Dados Estratégicos' },
    InformacoesGerenciaisSenac: { id: "EDA094D6-2E79-4F7B-B41C-57DAA692FA33", nome: 'Informações Gerenciais Senac' },
    UnidadesFisicas: { id: "79FDF6F6-47D7-4187-930C-5DB0FFBEBAE5", nome: 'Unidades Físicas' },
    TransparenciaPrestacaoContas: { id: "41CD60A3-6A77-4C23-861A-61D934940CE9", nome: 'Transparência e Prestação de Contas' },
    Seguranca: { id: "EC71CA04-4A71-41CF-AC2B-716A72FC34A5", nome: 'Segurança' },
    ControleContribuintesSenac: { id: "36793AD0-BA97-4ECE-8994-84B1A1901733", nome: 'Controle dos Contribuintes Senac' },
    FaturamentoSistemas: { id: "3215F047-1A95-4309-9C20-BBFCA34C8DC8", nome: 'Faturamento de Sistemas' },
    Comunicacao: { id: "52A6BDCB-B100-48A2-A6C6-D45D15FB2398", nome: 'Comunicação' },
    SIC: { id: "5BCEB271-08A8-4B82-8392-E2F055D83BFE", nome: 'SIC' },
    PainelMetas: { id: "D964CB2C-F958-426C-A1A8-EC4FF7EC1804", nome: 'Painel de Metas' },
    IntegracaoProvidencias: { id: "B579336B-CA8A-4DEA-B36F-EF3490E5915D", nome: 'Integração Providências' }
}


// WEBPACK FOOTER //
// ./src/app/shared/utils/enums/moduloIdEnum.ts